import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { formatUzs } from '../lib/format';
import { WorkshopSwitcher } from '../components/WorkshopSwitcher';
import { useAuth } from '../stores/auth';
import { StatusBadge } from '../components/StatusBadge';
import { timeAgo } from '../lib/format';

export function DashboardPage() {
  const auth = useAuth();
  const hasWorkshop = !!auth.activeWorkshop;

  const { data: stats, isLoading: loadingStats } = useQuery({
    queryKey: ['today-stats', auth.activeWorkshop?.id],
    queryFn: () => api.today(),
    enabled: hasWorkshop,
    refetchInterval: 30_000,
  });

  const { data: recent, isLoading: loadingRecent } = useQuery({
    queryKey: ['recent-orders', auth.activeWorkshop?.id],
    queryFn: () => api.listOrders({ pageSize: 5 }),
    enabled: hasWorkshop,
  });

  return (
    <>
      <WorkshopSwitcher />
      {!hasWorkshop && (
        <div className="card">
          <div className="empty">
            <div className="emoji">🏢</div>
            <div>Sizda faol usta yo'q</div>
            <div className="muted">Avval bot orqali usta yarating yoki a'zo bo'ling</div>
          </div>
        </div>
      )}
      {hasWorkshop && (
        <>
          <h3 style={{ marginTop: 12 }}>📊 Bugun</h3>
          {loadingStats ? (
            <div className="spinner" />
          ) : stats ? (
            <div className="stat-grid">
              <div className="stat-card received">
                <div className="stat-label">Qabul</div>
                <div className="stat-value">{stats.received}</div>
              </div>
              <div className="stat-card inProgress">
                <div className="stat-label">Jarayonda</div>
                <div className="stat-value">{stats.inProgress}</div>
              </div>
              <div className="stat-card ready">
                <div className="stat-label">Tayyor</div>
                <div className="stat-value">{stats.ready}</div>
              </div>
              <div className="stat-card delivered">
                <div className="stat-label">Topshirilgan</div>
                <div className="stat-value">{stats.delivered}</div>
              </div>
              <div className="stat-card revenue" style={{ gridColumn: '1 / -1' }}>
                <div className="stat-label">Daromad</div>
                <div className="stat-value amount">{formatUzs(stats.revenue)}</div>
              </div>
            </div>
          ) : null}

          <h3 style={{ marginTop: 18 }}>📋 Oxirgi buyurtmalar</h3>
          {loadingRecent ? (
            <div className="spinner" />
          ) : recent && recent.items.length > 0 ? (
            <div>
              {recent.items.map((o) => (
                <Link key={o.id} to={`/orders/${o.id}`} className="card" style={{ display: 'block' }}>
                  <div className="row-between" style={{ marginBottom: 6 }}>
                    <div style={{ fontWeight: 600 }}>🚗 {o.car.plate}</div>
                    <StatusBadge status={o.status} />
                  </div>
                  <div className="muted" style={{ marginBottom: 4 }}>
                    {o.car.brand} {o.car.model} · {o.client.name}
                  </div>
                  <div className="muted" style={{ fontSize: 12 }}>
                    {o.problem.length > 60 ? o.problem.slice(0, 60) + '…' : o.problem}
                  </div>
                  <div className="row-between" style={{ marginTop: 6 }}>
                    <div className="muted" style={{ fontSize: 11 }}>{timeAgo(o.receivedAt)}</div>
                    <div className="amount" style={{ fontWeight: 600 }}>{formatUzs(o.totalCached)}</div>
                  </div>
                </Link>
              ))}
              <Link to="/orders" className="btn btn-block" style={{ marginTop: 8 }}>
                Barchasini ko'rish →
              </Link>
            </div>
          ) : (
            <div className="empty">
              <div className="emoji">📭</div>
              <div>Hozircha buyurtmalar yo'q</div>
            </div>
          )}
        </>
      )}
    </>
  );
}
